var _rect, _rect2, _rect3, _rect4, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgExerciseChart = function SvgExerciseChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 60,
    viewBox: "0 0 99 60",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 14,
    height: 35,
    rx: 3,
    fill: "#FFBB40"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 14,
    height: 56,
    rx: 3,
    fill: "#6CCED4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 14,
    height: 60,
    rx: 3,
    fill: "#FF85A2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 14,
    height: 38,
    rx: 3,
    fill: "#00C0A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.0607 12.9393C87.4749 12.3536 86.5251 12.3536 85.9393 12.9393L76.3934 22.4853C75.8076 23.0711 75.8076 24.0208 76.3934 24.6066C76.9792 25.1924 77.9289 25.1924 78.5147 24.6066L87 16.1213L95.4853 24.6066C96.0711 25.1924 97.0208 25.1924 97.6066 24.6066C98.1924 24.0208 98.1924 23.0711 97.6066 22.4853L88.0607 12.9393ZM88.5 60L88.5 14H85.5L85.5 60H88.5Z",
    fill: "#FF6B00"
  })));
};

export default __webpack_public_path__ + "static/media/exercise-chart.3c22c00a.svg";
export { SvgExerciseChart as ReactComponent };